/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form/immutable';
import AlpsCreateVersionForm from './layout';
import { formValidation,versionsFormValidation } from '../validation';
import { getSelectedSubEntityId, isSubEntitySaving } from '../../../../redux/modules/entities/selectors';
import { subEntityFormSubmission } from '../../../../redux/modules/form/selectors';
import {
  selectCreateVersionFormInitialValues,
  selectTypeLabel,
  selectTypeLabelText,
  getActiveAction,
  selectSubTypeLabelText,
  selectSubtypeLabel,
  handlePendingSubmit,
  formTypeHasSubtypes,
  setAlpsFomrValues
} from '../../../../redux/modules/entities/alps/selectors';
import { entitiesMetaData } from '../../../../redux/modules/entities/metaData';
import { setSelectedSubEntityId } from '../../../../redux/modules/entities';
import { addToPendingSubmit, setTermsForm } from '../../../../redux/modules/entities/alps/actions';
import store from '../../../../redux/store';

const CreateAlpsCreateVersionForm = compose(
  connect((state) => ({
    form: `alpsVersion:${getSelectedSubEntityId(state)}`,
  })),
  reduxForm({
    onSubmit: (values, dispatch, props) => {
      handlePendingSubmit(values, dispatch, props, store.getState());
    },
    validate: versionsFormValidation,
    destroyOnUnmount: true,
  })
)(AlpsCreateVersionForm);

export function mapStateToProps(state) {
  var div =document.querySelectorAll("[id=sdpanel-submit]")[1]
  if(div){
  div.innerHTML = div.innerHTML.replace('Submit','Next');
  }
  return {
    actionTypes: entitiesMetaData.alps.actionTypes,
    isSaving: isSubEntitySaving(state),
    key: getSelectedSubEntityId(state),
    typeHasSubtypes: formTypeHasSubtypes(state),
    artifactTypeName:selectTypeLabelText(state),
    artifactSubType:selectSubTypeLabelText(state),
    activeAction:getActiveAction(state)
  };
}

export const actions = {
  setSelectedSubEntityId,
};

export default connect(mapStateToProps, actions)(CreateAlpsCreateVersionForm);
